import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectUser } from "../auth/authSelectors";
import { getDefaultRouteByRole } from "../utils/roleRoute";

const PublicBlockRoute = ({ children }) => {
  const user = useSelector(selectUser);

  // If no user → allow public access
  if (!user?.role) {
    return children;
  }

  const role = user.role.toLowerCase().trim();

  // Allow Public User to stay in public pages
  if (role === "public user") {
    return children;
  }

  // All other roles → redirect to their dashboard
  const redirect = getDefaultRouteByRole(user.role);
  console.log("🔁 Public blocked. Redirecting to:", redirect);

  return <Navigate to={redirect} replace />;
};

export default PublicBlockRoute;
